<template>
  <div class="lines-bg padding-header">
    <h1 class="text-center px-2 font-black text-5xl uppercase pt-8 md:pt-12 mb-4 md:mb-10">{{page.fields.title}}</h1>
    <div class="px-4 wrapper mx-auto mb-8">
      <page-sections :sections="page.fields.children" class="flex flex-wrap justify-center" />

      <div  class="flex flex-wrap justify-center pb-6">
        <div class="w-64 lg:text-center w-full">
          <h2 class="font-black uppercase text-3xl leading-tight mb-4 w-full">Locations</h2>
        </div>

        <div class="w-64 lg:text-center w-full">
          <nuxt-link to="/locations/" class="block uppercase my-2">Location Search</nuxt-link>
        </div>

        <div class="w-64 lg:text-center" v-for="location in locations">
          <nuxt-link :to="'/locations/'+location.path" class="block uppercase my-2">{{location.name}}</nuxt-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PageSections from '~/components/PageSections'

export default {
  components: {
    PageSections
  },
  computed: {
    locations() {
      return this.$store.state.centerData
    },
  },
  asyncData: async function({ $api }) {
    return {
      page: await $api.getPage('site-map'),
    }
  },
  head: function() {
    return this.$metadata(this.page)
  },
}
</script>